import React from 'react';
import AccountSettingsComponent from '@components/account-settings';

const AccountSettings = () => {
  return <AccountSettingsComponent />;
};

export default AccountSettings;
